import React, { Component } from 'react'
import images from '../../config/images'
import AppBartemp from 'material-ui/AppBar'
import Display from 'material-ui/svg-icons/av/airplay'
import Profile from '../../components/Profile/NavBarProfile'
import { FormattedMessage } from 'react-intl'
import Chip from 'material-ui/Chip'
import NotificationSystem from 'react-notification-system'

const Title = ({mode, tableName, confName}) => (
  <div className='flex items-center'>
    <Display style={{fill: '#fff'}}/>
    <div style={{fontSize: 20, marginLeft: '10px'}}>
      {confName}
    </div>
  </div>
)

const backgroundImage = () => 'linear-gradient(135deg, #3186f9 0%, #3186f9 30%, #3186f9 90%, #3186f9 100%)'

class AppBar extends Component {
  constructor (props) {
    super(props)
    this.notificationSystem = React.createRef()
  }

  render () {
    const {direct, location, mode, tableName, user_id, name, role, email, init, confName} = this.props
    const notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          fontSize: '14px',
          height: '2.5vw',
          width: '25vw',
          right: '5vw',
          top: '-4vw !important'
        }
      }
    }
    return (<div>
        <AppBartemp
          className='pr3 pl3'
          style={{
            backgroundImage: backgroundImage(),
            zIndex: 100,
            height: '6vh',
            position: 'unset'
          }}
          title={
            <div className='flex items-cente justify-between w-100'>
              <div>
                <div className='pl3 flex justify-around flex-column'
                     style={{position: 'absolute', top: '1.0vh', left: '1vw', height: '4vh'}}>
                  <img src={images.webinar_logo} alt="logo" style={{width: 120, cursor: 'pointer'}}
                       onClick={() => {window.open('https://webinar.freshvoice.net/')}}/>
                </div>
                <div className='pl3 flex justify-around flex-column'
                     style={{position: 'absolute', top: '1.0vh', left: '25vw', height: '4vh'}}>
                  {!init && <Chip backgroundColor='#ffc514'>
                    <div className='white ttu'>
                      {(mode == 'seminar') ? (<FormattedMessage id='main.seminar'/>) : (
                        <FormattedMessage id='main.breakout'/>)}
                    </div>
                  </Chip>}
                </div>
                <div className='pl3 flex justify-around flex-column'
                     style={{position: 'absolute', top: '1.0vh', left: '50vw', height: '4vh'}}>
                  {!init && <div className='w-60 flex justify-center'>
                    <Title mode={mode} tableName={tableName} confName={confName}/>
                  </div>}
                </div>
              </div>
              <div className='w-20'/>
            </div>
          }
          iconElementRight={<Profile direct={direct} user_id={user_id} name={name} role={role}
                                                       email={email} location={location}/>}
          showMenuIconButton={false}
        />
        <div>
          <NotificationSystem ref={this.notificationSystem} style={notificationStyle}/>
        </div>
      </div>
    )
  }
}

export default AppBar



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/AppBar.js